// ActiveCampaignsActions.jsx
import { useContext, useEffect, useRef, useState } from "react";
import "./ActiveCampaignsActions.css";
import { Context } from "../../../../context/Context";
import { fetchActionsAPI } from "../../../../utils/api/actions";
import { translations } from "../../../../utils/lang";
import { APP_COLORS } from "../../../../utils/helpers";
import { ExpandableText } from "../../../ui";
import ActionWorkflowButtons from "../../campaignActions/ActionWorkflowButtons";

// The activated campaigns of a restaurant (step 4 of the Actions workflow). Completing
// one is the workflow's own, confirmed action - the same button the action cards,
// the Operations table and the Dashboard use; the server decides who sees it.
export default function ActiveCampaignsActions({ storeId, appName, refreshKey, onRefresh }) {
  const { lang, handleTokenExpiration } = useContext(Context);
  const [actions, setActions] = useState([]);
  const tokenExpiredRef = useRef(handleTokenExpiration);
  tokenExpiredRef.current = handleTokenExpiration;
  const expand = {
    expand: lang === "ar" ? "اضغط لعرض النص كاملاً" : "Click to show the full text",
    collapse: lang === "ar" ? "اضغط لطيّ النص" : "Click to collapse the text",
  };

  useEffect(() => {
    let active = true;
    const token = localStorage.getItem("auth-token");
    if (!token) {
      tokenExpiredRef.current();
      return undefined;
    }

    fetchActionsAPI(token, {
      storeId,
      appName,
      status: "active",
      type: "campaigns",
    }).then((res) => {
      if (!active) return;
      if (res) {
        setActions(res);
      } else {
        // Existing behaviour: a failed load is treated as an expired session.
        tokenExpiredRef.current();
      }
    });

    return () => {
      active = false;
    };
  }, [storeId, appName, refreshKey]);

  return (
    <div className="operation-card">
      <div className="operation-card-container">
        <h4 className="operation-card-section-title">{translations[lang].Operation.activeCampaigns}</h4>

        <div className="active-campaigns-list">
          {actions.length === 0 && <span className="empty-text">{translations[lang].Operation.noActiveCampaigns}</span>}

          {actions.map((action) => (
            <div key={action._id} className="active-campaign-row">
              <div className="operation-app-source">
                {appName === "LUD" && action.appName && (
                  <span
                    className="operation-app-indicator"
                    style={{ backgroundColor: APP_COLORS[action.appName] || "var(--ui-border)" }}
                    role="img"
                    data-app-name={action.appName}
                    title={action.appName}
                    aria-label={action.appName}
                  />
                )}
                <ExpandableText className="active-campaign-text" text={action.content} lines={1} threshold={40} labels={expand} />
              </div>

              <ActionWorkflowButtons id={action._id} allowed={action.allowed} action={action} lang={lang} onDone={() => onRefresh?.()} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
